import moment from 'moment'
import echarts from '@/config/echarts/index.js'

export function getDaysForecastOption (icon, desc, xData) {
  const data = []
  return {
    backgroundColor: 'rgba(128, 128, 128, 0)',
    title: {},
    grid: {
      left: '25px',
      right: '35px',
      bottom: '30px',
      top: '70px'
    },
    legend: {
      show: true,
      itemGap: 30,
      textStyle: {
        color: '#FFF',
        fontSize: '0.8rem'
      }
    },
    tooltip: {
      trigger: 'axis',
      formatter (params) {
        let html = `${moment(Number(params[0].axisValue)).format('YYYY-MM-DD HH:mm')}</br>`
        params.forEach((item, index) => {
          if (item.seriesName === '天气现象') {
            const src = require(`@/assets/images/weatherIcon_p/${icon[item.dataIndex]}.png`)
            html += `${item.marker}${item.seriesName}: ${desc[item.dataIndex]} <img style='width:1.6vw;height:1.6vw; vertical-align: middle;' src='${src}' />`
          } else if (item.seriesName === '温度') {
            html += `${item.marker}${item.seriesName}: ${item.value} ℃<br/>`
          } else {
            html += `${item.marker}${item.seriesName}: ${item.value} mm<br/>`
          }
        })
        return html
      }
    },
    xAxis: {
      // show: false,
      // boundaryGap: false,
      data: data,
      axisLine: {
        show: true,
        onZero: false,
        lineStyle: {
          type: 'solid',
          color: '#979797'
          // width: '0.05vw'
        }
      },
      axisLabel: {
        show: true,
        color: ' #FFF',
        fontSize: '0.73vw',
        formatter: function (value) {
          return moment(Number(value)).format('HH')
        }
      },
      axisTick: {
        inside: true
      },
      splitLine: {
        show: true,
        interval: (index) => {
          if (index !== 0) {
            const lastDay = moment(xData[index]).format('DD')
            const beforeDay = moment(xData[index - 1]).format('DD')
            if (beforeDay !== lastDay) {
              return true
            }
          }
        },
        lineStyle: {
          type: 'dashed',
          color: '#ccc',
          Text: 'aasdas'
          // width: '0.05vw'
        }
      }
    },
    yAxis: [
      {
        type: 'value',
        name: '(℃)',
        // nameLocation: 'end',
        nameTextStyle: {
          fontSize: '0.9rem',
          align: 'right',
          color: '#FFF'
        },
        splitLine: {
          show: false
        },
        axisLabel: {
          color: '#FFF',
          fontSize: '0.9rem'
        }
      },
      {
        type: 'value',
        name: '(mm)',
        // nameLocation: 'end',
        nameTextStyle: {
          fontSize: '0.9rem',
          align: 'left',
          color: '#FFF'
        },
        splitLine: {
          show: false
        },
        max: 5,
        axisLabel: {
          color: '#FFF',
          fontSize: '0.9rem'
        }
      }
    ],
    series: [{
      type: 'line',
      name: '温度',
      smooth: true,
      data: [],
      markPoint: {
        show: true,
        symbol: 'rect',
        symbolSize: [30, 20],
        symbolOffset: ['-50%', 0],
        itemStyle: {
          normal: {
            color: 'transparent',
            label: {
              show: true,
              color: '#ffffff'
            }
          }
        },
        data: []
      },
      yAxisIndex: 0,
      showBackground: true,
      backgroundStyle: {
        color: 'rgba(180, 180, 180, 0.2)'
      },
      label: {
        show: false,
        position: 'top',
        fontSize: '0.75rem'
      }
    }, {
      yAxisIndex: 1,
      type: 'bar',
      name: '雨量',
      data: [],
      label: {
        show: true,
        position: 'top',
        color: '#FFF',
        fontSize: '0.9rem',
        formatter: function (pramss) {
          return pramss.data > 0 ? pramss.data : ''
        }
      },

      color: new echarts.graphic.LinearGradient(0, 1, 0, 0, [
        {
          offset: 1,
          color: 'rgba(88, 223, 217, 1)'
        },
        {
          offset: 0.5,
          color: 'rgba(88, 223, 217, 0.5)'
        },
        {
          offset: 0,
          color: 'rgba(255, 255, 255, 0)'
        }
      ]),
      itemStyle: {
        normal: {
          barBorderRadius: [10, 10, 0, 0]
        }
      }
    },
    {
      type: 'scatter',
      name: '天气现象',
      symbolSize: 10,
      icon: '',
      z: 10,
      label: {
        show: true,
        offset: [0, 0],
        formatter (params) {
          return `{${params.dataIndex}|}`
        },
        rich: {}
      }
    }]
  }
}

// {
//   data: [150, 230, 224, 218, 135, 147, 260],
//     type: 'scatter',
//       // symbolSize:10,
//       label: {
//     show: true,
//       offset: [0, 0],
//         formatter: '{a|}',
//           rich: {
//       a: {
//         color: 'red',
//           backgroundColor: {
//           image: 'https://d.scggqx.com/forecast/img/%E5%B0%8F%E9%9B%A8.png'
//         },
//         // fontSize:0,
//         height: 40
//       }
//     }
//   }

// }
